/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: GCI 2020
  Author: Dtsmart
  Author URL: http://dtsmart.vn
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"
import checkinModule from "./checkin/index"
import StaffListModule from "./staffList/index"
import CustomerListModule from "./customerList/index"
import ServiceListModule from "./serviceList/index"
import PromoListModule from './promoList/index'
import ReviewListModule from './reviewList/index'
import AuthModule from './auth/moduleAuth'
import RewardModule from './rewardList/index'
import moduleChat from './chat/moduleChat.js'
import dashboardModule from './dashboard/index'
import invoiceModule from './invoiceList/index'

import appointmentModule from './appointment/index'
import serviceModule from './appointmentService/index'
import staffModule from './appointmentStaff/index'
import customerModule from './appointmentCustomer/index'
import businessModule from './appointmentBusiness/index'
// import appointmentAuthModule from './appointmentAuth/index'
import appModule from './appSetting/index'
import notifyModule from './notify/index'

import posAppointment from './posAppointment/index'

//Order modules
import OrderModule from './orderOrder/index'
import ItemModule from './orderItem/index'
import ModifierModule from './orderModifier/index'
import CategoryModule from './orderCategory/index'
import OrderInvoiceModule from './orderInvoice/index'

//goPos
import goPosModule from './goPos/index'
import smsCount from './smsCount/index'
import callModule from './call/index'


Vue.use(Vuex)


export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    checkin: checkinModule,
    staffList: StaffListModule,
    customerList: CustomerListModule,
    serviceList: ServiceListModule,
    promoList: PromoListModule,
    reviewList: ReviewListModule,
    rewardList: RewardModule,
    auth: AuthModule,
    chat: moduleChat,
    appointment: appointmentModule,
    service: serviceModule,
    staff: staffModule,
    customer: customerModule,
    business: businessModule,
    // auth: appointmentAuthModule
    appSetting: appModule,
    dashboard: dashboardModule,
    notify: notifyModule,
    invoiceList: invoiceModule,
    order: OrderModule,
    item: ItemModule,
    modifier: ModifierModule,
    category: CategoryModule,
    orderInvoice: OrderInvoiceModule,
    goPos: goPosModule,
    posAppointment: posAppointment,
    smsCount: smsCount,
    call: callModule
  },
  strict: process.env.NODE_ENV !== 'production'
})
